import { render, staticRenderFns } from "./DropdownSelect.vue?vue&type=template&id=1840ccd6&scoped=true"
import script from "./DropdownSelect.vue?vue&type=script&lang=js"
export * from "./DropdownSelect.vue?vue&type=script&lang=js"
import style0 from "./DropdownSelect.vue?vue&type=style&index=0&id=1840ccd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1840ccd6",
  null
  
)

export default component.exports